import scrollToElement from 'scroll-to-element';

// https://easings.net/de

export function scrollTo(element, offset = 0, duration = 800, ease = 'out-expo') {
  scrollToElement(element, {
    offset,
    duration,
    ease,
  });
}
